
export const CARD_COLLAPSED = 'collapsed';
export const CARD_DISMISSED = 'dismissed';
export const CARD_OPEN = 'open';
